/**
 * Regelversion 12: Erfolgsmoment „Problem gelöst“.
 *
 * Für jedes aktive Problem wird monatlich der Problemdruck mitgeschrieben (höchstens 48 Werte). Eine Karte mit Verlauf,
 * Gesetz, den Gruppen, die profitieren, und einem eingelösten Wahlversprechen erscheint,
 *  - wenn ein eigenes Gesetz voll wirkt und den Druck seit dem Höchststand um mindestens 25 Punkte auf unter 45 gesenkt hat
 *    („entschärft“), oder
 *  - wenn ein Problem ganz von der Liste verschwindet und ein eigenes Gesetz dazu beigetragen hat („gelöst“).
 * Zieht keinen Zufall, nur im Einzelspieler.
 */
import { S } from './state';
import { since } from './version';

export const winOn = (): boolean => since(12) && !S.mp;
const A = () => S as any;
export type Win = { k: 'gelöst' | 'entschärft'; iss: string; n: string; m: number; from: number; to: number; law: string | null; lawM: number | null; m0: number; h: number[]; g: Record<string, number>; prom: boolean };
export const wins = (): Win[] => (A().wins ??= []);

/** Monatlich in der Regierungszeit: Verlauf mitschreiben. */
export function winTrack() {
  if (!winOn() || S.phase !== 'govern') return;
  for (const k in S.issues) {
    const st: any = S.issues[k]; if (!st.on) continue;
    const h: number[] = (st.h ??= []), m0: number = (st.hm ??= S.m);
    h.push(Math.round(st.sev)); if (h.length > 48) { h.shift(); st.hm = m0 + 1; }
  }
}
/** Aus issueLifecycle, wenn ein Problem gelöst ist. */
export function winSolved(id: string, name: string) {
  if (!winOn()) return;
  const st: any = S.issues[id];
  const own = (S.laws || []).filter((L: any) => L.iss === id && (!L.by || L.by === 'YOU') && !L.bestand && ['kraft', 'done'].includes(L.stage)).sort((a: any, b: any) => (b.doneM ?? S.m) - (a.doneM ?? S.m))[0] as any;
  const h: number[] = st.h || [];
  if (own) {
    const g: Record<string, number> = {}; for (const k in own.fx?.g || {}) if (own.fx.g[k] >= .5) g[k] = Math.round(own.fx.g[k] * (own.q || 1) * 10) / 10;
    const prom = (S.promises || []).some((p: any) => p.k === 'iss' && p.iss === id && p.leg === S.leg);
    const W: Win = { k: 'gelöst', iss: id, n: name, m: S.m, from: h.length ? Math.max(...h) : Math.round(st.sev), to: Math.round(st.sev), law: own.t, lawM: own.doneM != null ? own.doneM - (own.vn || 6) : null, m0: st.hm ?? S.m, h: h.slice(), g, prom };
    wins().push(W); A().winCard = W;
  }
  st.h = []; st.hm = null; st.won = false;
}
/** Ein eigenes Gesetz wirkt voll (Aufruf aus tick, wenn es fertig ist). */
export const WIN_DROP = 25, WIN_BELOW = 45;
export function winLawDone(L: any, name: string) {
  if (!winOn() || !L?.iss || (L.by && L.by !== 'YOU') || L.bestand || L.rep) return;
  const st: any = S.issues[L.iss]; if (!st?.on) return;
  const h: number[] = st.h || [], peak = h.length ? Math.max(...h) : st.sev;
  if (peak - st.sev < WIN_DROP || st.sev >= WIN_BELOW || st.won) return;
  st.won = true; // höchstens einmal je Problem, bis es gelöst ist oder wiederkommt
  const g: Record<string, number> = {}; for (const k in L.fx?.g || {}) if (L.fx.g[k] >= .5) g[k] = Math.round(L.fx.g[k] * (L.q || 1) * 10) / 10;
  const prom = (S.promises || []).some((p: any) => p.k === 'iss' && p.iss === L.iss && p.leg === S.leg);
  const W: Win = { k: 'entschärft', iss: L.iss, n: name, m: S.m, from: Math.round(peak), to: Math.round(st.sev), law: L.t, lawM: S.m - (L.vn || 6), m0: st.hm ?? S.m, h: h.slice(), g, prom };
  wins().push(W); A().winCard = W;
}
export function winOk() { A().winCard = null; }
